import axios from "axios";
import { logout } from "../lib/auth";

import {
  dataDifine,
  EditDataDifine,
  DataColumn,
} from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

//  顧客一覧取得
export async function getContracts(
  props: { [key: string]: number | string },
  sortColumn: {
    key: string;
    sort: string;
  }[],
  screenColumn: DataColumn[]
) {
  try {
    const path = "contracts";
    const params = makeParams(screenColumn, props);
    const response = await axios.get(CONST.apiUrl + path, {
      params: { ...params, sortColumn },
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const contracts: dataDifine[] = response.data.fetch_data;
    const countContracts: string = response.data.count_data;
    return { contracts, countContracts };
  } catch (error) {
    // logout();
  }
}

// 顧客詳細取得
export async function getContract(id: string, service_id: string) {
  try {
    const path = "contract";
    const params = { id, service_id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const detail_data: {
      [key: string]: number | string | { [key: string]: string | string[] };
    } = response.data.detail_data[0];
    const option_data: {
      [key: string]: string | number;
    }[] = response.data.option_data;
    const contract_history: {
      selected_date: string;
      contract_version: number;
    }[] = response.data.contract_history;
    return { detail_data, option_data, contract_history };
  } catch (error) {
    // logout();
    return { detail_data: {}, option_data: [], contract_history: [] };
  }
}

// 顧客情報編集
export async function putContract(editData: EditDataDifine) {
  try {
    const path = "contract";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
      editPhoneNumber: editData.editPhoneNumber,
      editName: editData.editName,
      editCustomerName: editData.editCustomerName,
      tel_flg: editData.tel_flg,
      name_flg: editData.name_flg,
      company_name_flg: editData.company_name_flg,
      half_width_number_flg: editData.half_width_number_flg,
      editType: editData.editType,
    };
    const response = await axios.put(CONST.apiUrl + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 顧客情報登録
export async function postContract(addData: {
  productId: number | null;
  phone_number: string;
  customer_name: string;
  servicePlanName: string;
  serviceContentNameList: string[];
  serviceCampaignPulldownName: string;
  serviceCampaignCheckboxName: string[];
  servicePaymentMethodName: string;
  serviseCustomerListID: string;
  customerInfo: { [key: string]: string | string[] };
  changeAccount: 0 | 1;
  changeAccountID: number | null;
}) {
  try {
    const path = "contract";
    const bodys = addData;
    const response = await axios.post(CONST.apiCognitoUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 顧客情報登録
export async function postContractShortMessage(
  addData: {
    productId: number | null;
    productName: string;
    phone_number: string;
    customer_name: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    customerInfo: { [key: string]: string | string[] };
    site_path: string;
    outsideMessageType: number | null;
    smsMessagePatternID: number | null;
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  },
  mail_address: string,
  toss_up_id: string,
  closing_memo: string
) {
  try {
    const path = "contract/shortMessage";
    const bodys = {
      productId: addData.productId,
      productName: addData.productName,
      phone_number: addData.phone_number,
      customer_name: addData.customer_name,
      serviseCustomerListID: addData.serviseCustomerListID,
      pullDownServiceName: addData.pullDownServiceName,
      checkBoxServiceNames: addData.checkBoxServiceNames,
      customerInfo: addData.customerInfo,
      site_path: addData.site_path,
      outsideMessageType: addData.outsideMessageType,
      smsMessagePatternID: addData.smsMessagePatternID,
      changeAccount: addData.changeAccount,
      changeAccountID: addData.changeAccountID,
      mail_address,
      toss_up_id,
      closing_memo,
    };
    const response = await axios.post(CONST.apiCognitoUrl + path, {
      bodys,
    });
    const postResponce: string = response.data.add;
    const outsideSiteUrl: string = response.data.outside_site_url;
    const outsideServiceUrl: string = response.data.outside_service_url;
    const viewOutsideServiceUrl = response.data.viewOutsideServiceUrl as 0 | 1;

    return {
      postResponce,
      outsideSiteUrl,
      outsideServiceUrl,
      viewOutsideServiceUrl,
    };
  } catch (error) {
    // logout();
    return {
      postResponce: "failed",
      outsideSiteUrl: "",
      outsideServiceUrl: "",
      viewOutsideServiceUrl: 0 as 0 | 1,
    };
  }
}

export async function getContractProducts(
  changeAccount: 0 | 1,
  changeAccountID: number | null
) {
  try {
    const path = "contract/add/products";
    const params = { changeAccount, changeAccountID };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const fetch_data: {
      id: number;
      product_id: number;
      product_name: string;
      have_entry_form: number;
      site_path_list: string[];
    }[] = response.data.fetch_data;
    return fetch_data;
  } catch (error) {
    // logout();
    return [];
  }
}

export async function getContractProduct(
  id: number,
  outSiteEntry: 0 | 1,
  site_path: string,
  changeAccount: 0 | 1,
  changeAccountID: number | null
) {
  try {
    const path = "contract/add/product";
    const params = {
      id,
      outSiteEntry,
      site_path,
      changeAccount,
      changeAccountID,
    };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    // 内部エントリー用のデータ
    const service_plan_data: { service_name: string }[] =
      response.data.service_plan_data ?? [];
    const service_content_data: { service_name: string }[] =
      response.data.service_content_data ?? [];
    const service_campaign_pulldown_data: { service_name: string }[] =
      response.data.service_campaign_pulldown_data ?? [];
    const service_campaign_checkbox_data: { service_name: string }[] =
      response.data.service_campaign_checkbox_data ?? [];
    const service_payment_data: { payment_method: string }[] =
      response.data.service_payment_data ?? [];
    const option_data: {
      [key: string]: string | number;
    }[] = response.data.option_data ?? [];

    // 外部エントリー用のデータ
    const outside_pull_down_service: { service_name: string }[] =
      response.data.outside_pull_down_service ?? [];
    const outside_check_box_service: { service_name: string }[] =
      response.data.outside_check_box_service ?? [];
    const outside_option_data: {
      [key: string]: string | number;
    }[] = response.data.outside_option_data ?? [];
    const outside_sms_patterns: {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_body: string;
    }[] = response.data.outside_sms_patterns ?? [];
    const outside_mail_patterns: {
      id: number;
      outside_sms_name: string;
      outside_sms_sender: string;
      outside_sms_title: string;
      outside_sms_body: string;
    }[] = response.data.outside_mail_patterns ?? [];

    return {
      service_plan_data,
      service_content_data,
      service_campaign_pulldown_data,
      service_campaign_checkbox_data,
      service_payment_data,
      option_data,
      outside_pull_down_service,
      outside_check_box_service,
      outside_option_data,
      outside_sms_patterns,
      outside_mail_patterns,
    };
  } catch (error) {
    // logout();
    return {
      service_plan_data: [],
      service_content_data: [],
      service_campaign_pulldown_data: [],
      service_campaign_checkbox_data: [],
      service_payment_data: [],
      option_data: [],
      outside_pull_down_service: [],
      outside_check_box_service: [],
      outside_option_data: [],
      outside_sms_patterns: [],
      outside_mail_patterns: [],
    };
  }
}

// 契約データ無効化
export async function deleteContract(id: string) {
  try {
    const path = "contract";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}

// 契約データ個人情報削除
export async function deletePersonContract(id: string) {
  try {
    const path = "contract/person";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}

// 解約時SMS設定一覧取得（accessDB）
export async function getCancellSmsOptions(contractId: string): Promise<{
  cancell_sms_list: {
    id: number;
    cancell_sms_name: string;
    cancell_sms_type: number;
    cancell_sms_sender: string;
    cancell_sms_body: string;
    cancell_sms_title: string;
    source: "product" | "outside_entry_form";
  }[];
  destination_phone_number: string;
  destination_mail_address: string;
}> {
  try {
    const path = "contract/cancell";
    const response = await axios.get(CONST.apiUrl + path, {
      params: { id: contractId },
    });
    const list = response.data?.cancell_sms_list;
    return {
      cancell_sms_list: Array.isArray(list) ? list : [],
      destination_phone_number: response.data?.destination_phone_number ?? "",
      destination_mail_address: response.data?.destination_mail_address ?? "",
    };
  } catch (error) {
    return {
      cancell_sms_list: [],
      destination_phone_number: "",
      destination_mail_address: "",
    };
  }
}

// 契約データ解約（selectedCancellSms: null は送信しない）
export async function cancellContract(
  id: string,
  selectedCancellSms: { id: number; source: "product" | "outside_entry_form" } | null
) {
  try {
    const path = "contract/cancell";
    const params: { id: string; cancell_sms_id?: number; cancell_sms_source?: string } = {
      id,
    };
    if (selectedCancellSms) {
      params.cancell_sms_id = selectedCancellSms.id;
      params.cancell_sms_source = selectedCancellSms.source;
    }
    const response = await axios.delete(CONST.apiCognitoUrl + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}

// 契約データトスアップ複製前の事前情報取得用
export async function getContractCopyTossUpAddBefore(
  contract_id: string,
  changeAccount: 0 | 1,
  changeAccountID: number | null
) {
  try {
    const path = "contract/copy/before";
    const params = { contract_id, changeAccount, changeAccountID };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    return {
      tossUpCategoryNameList: response.data.tossUpCategoryNameList as {
        category_id: number;
        category_name: string;
      }[],
      tossUpProductNameList: response.data.tossUpProductNameList as {
        category_id: number;
        category_name: string;
        product_name: string;
      }[],
      contract_data: response.data.contract_data[0] as {
        [key: string]: string | number | { [key: string]: string | string[] };
      },
    };
  } catch (error) {
    // logout();
    return {
      tossUpCategoryNameList: [],
      tossUpProductNameList: [],
      contract_data: {},
    };
  }
}

// 契約データトスアップ複製前のトスアップフォーム取得用
export async function getContractCopyTossUpAddForm(
  contract_id: string,
  category_id_list: number[],
  product_name_list: string[],
  changeAccount: 0 | 1,
  changeAccountID: number | null
) {
  try {
    const path = "contract/copy/form";
    const params = {
      contract_id,
      category_id_list,
      product_name_list,
      changeAccount,
      changeAccountID,
    };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    const option_data: {
      [key: string]: string | number | string[];
    }[] = response.data.option_data;
    const before_option_data: {
      [key: string]: string | number;
    }[] = response.data.before_option_data;
    return {
      option_data,
      before_option_data,
    };
  } catch (error) {
    // logout();
    return { option_data: [], before_option_data: [] };
  }
}

// エントリー複製前の事前情報取得用
export async function getContractCopyEntryBefore(
  contract_id: string,
  changeAccount: number,
  changeAccountID: number | null
) {
  const path = "contract/copy-entry/before";
  const params = { contract_id, changeAccount, changeAccountID };
  const response = await axios.get(CONST.apiUrl + path, { params });
  return {
    contract_data: response.data.contract_data,
    entryProductList: response.data.entry_product_list,
    beforeOptionData: response.data.before_option_data,
  };
}

// 契約編集前のプラン・コンテンツ・キャンペーン一覧取得
export async function getContractEditBefore(id: string, product_id: string) {
  try {
    const path = "contract/edit/before";
    const params = {
      id,
      product_id,
    };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    // 内部エントリー用のデータ
    const product_name: string = response.data.product_name;
    const service_plan_data: { service_name: string }[] =
      response.data.service_plan_data;
    const service_content_data: { service_name: string }[] =
      response.data.service_content_data;
    const service_campaign_pulldown_data: { service_name: string }[] =
      response.data.service_campaign_pulldown_data;
    const service_campaign_checkbox_data: { service_name: string }[] =
      response.data.service_campaign_checkbox_data;
    const servicePlanName: string = response.data.servicePlanName;
    const serviceContentNameList: string[] =
      response.data.serviceContentNameList;
    const serviceCampaignPulldownName: string =
      response.data.serviceCampaignPulldownName;
    const serviceCampaignCheckboxName: string[] =
      response.data.serviceCampaignCheckboxName;
    return {
      product_name,
      service_plan_data,
      service_content_data,
      service_campaign_pulldown_data,
      service_campaign_checkbox_data,
      servicePlanName,
      serviceContentNameList,
      serviceCampaignPulldownName,
      serviceCampaignCheckboxName,
    };
  } catch (error) {
    // logout();
    return {
      product_name: "",
      service_plan_data: [],
      service_content_data: [],
      service_campaign_pulldown_data: [],
      service_campaign_checkbox_data: [],
      servicePlanName: "",
      serviceContentNameList: [],
      serviceCampaignPulldownName: "",
      serviceCampaignCheckboxName: [],
    };
  }
}
